import React, { useCallback } from "react";
import { useField } from "formik";
import { Checkbox } from "@design-system/Checkbox/Checkbox";

export const ApplyRuleToExistingTransactions: React.FC<{
    label: string;
}> = ({ label }) => {
    const [field, , helpers] = useField<boolean>("applyToExistingTransactions");
    const [, , { setValue: setExcludedTransactions }] = useField<number[]>(
        "excludedTransactionsIds",
    );
    const [, , { setValue: setIncludedTransactions }] = useField<number[]>(
        "includedTransactionsIds",
    );

    const toggle = useCallback(() => {
        helpers.setValue(!field.value);
        setExcludedTransactions([]);
        setIncludedTransactions([]);
    }, [
        field.value,
        helpers,
        setExcludedTransactions,
        setIncludedTransactions,
    ]);

    return (
        <Checkbox
            checked={!field.value}
            onCheckedChange={toggle}
            label={label}
        />
    );
};
